import axios from 'axios'
import Global from '../utils/global'
import router from "../router";
const baserurl = Global.baserurl
// 创建一个axios实例
const service = axios.create({
  // 请求超时时间
  timeout: 15000,
})

// 添加请求拦截器
service.interceptors.request.use(
  (config) => {
    let token = window.localStorage.getItem('accessToken')
    config.headers.token = token
    config.url = baserurl + config.url
    return config
  },
  (err) => {
    console.log(err)
  }
)
// 是否正在刷新的标记
let isRefreshing = false;
//重试队列
let requests = []
service.interceptors.response.use(
  (response) => {
     //处理token过期
    if (response.data.statusCode == 205) {
      if (!isRefreshing) {
        localStorage.removeItem("accessToken");
        isRefreshing = true;
        let i = response.config.url.indexOf(baserurl);
        response.config.url = response.config.url.substring(
          i > -1 ? baserurl.length : 0
        );
        return axios
          .get(
            baserurl +
              "User/GetRefreshToken?refreshToken=" +
              localStorage.getItem("accessToken")
          )
          .then((res) => {
            if(res.data.statusCode==205){
              
            isRefreshing = false;
              router.push("/login");
               return;
            }
            const { token } = res.data.tnToken.tokenStr;
            localStorage.setItem("accessToken", res.data.tnToken.tokenStr);
            
            response.headers.Authorization = `${token}`;
            requests.forEach((cb) => cb());
            requests = []; // 重新请求完清空
            isRefreshing = false;
            return service(response.config);
          }).catch(err=>{
            console.log(err)
            router.push("/login");
          });
      } else {
        let i = response.config.url.indexOf(baserurl);
        response.config.url = response.config.url.substring(
          i > -1 ? baserurl.length : 0
        );
        // 返回未执行 resolve 的 Promise
        return new Promise((resolve) => {
          // 用函数形式将 resolve 存入，等待刷新后再执行
          requests.push((token) => {
            response.headers.Authorization = `${token}`;
            resolve(service(response.config));
          });
        });
      }
    }
    return response.data
  },
  (err) => {
    console.log(err)
    let relust = {
      message: '服务错误请联系管理员',
      statusCode: 404,
    }
    return relust
  }
)

export default service
